export const SEARCH_PAGE_SIZE_OPTIONS = [50, 75, 100];

export const SEARCH_CATEGORIES = [
  {
    id: 'loan_advisor_name',
    label: 'Loan Advisor',
  },
  {
    id: 'manager_name',
    label: 'Sales Manager',
  },
  {
    id: 'borrower_phone_number',
    label: 'Phone Number',
  },
  {
    id: 'loan_id',
    label: 'Loan Number',
  },
];

export const HEIGHTS = {
  TABLE_CARD: 600,
};

// For real-time input validation
export const validationRules: Record<string, { regex: RegExp; message: string }> = {
  borrower_phone_number: {
    regex: /[^0-9()\-+\s.]/,
    message: 'Invalid characters for a phone number',
  },
  loan_id: {
    regex: /\D/,
    message: 'Please enter numbers only',
  },
  loan_advisor_name: {
    regex: /[^a-zA-Z\s]/,
    message: 'Please enter letters only',
  },
  manager_name: {
    regex: /[^a-zA-Z\s]/,
    message: 'Please enter letters only',
  },
};

export const PHONE_NUMBER_PATTERNS: RegExp[] = [
  // 10-digit formats (no country code)
  /^\d{10}$/, // XXXXXXXXXX (no separators)
  /^\d{3}[-.\s]\d{3}[-.\s]\d{4}$/, // XXX-XXX-XXXX (consistent separators)
  /^\(\d{3}\)\s?\d{3}[-.\s]?\d{4}$/, // (XXX)XXX-XXXX or (XXX) XXX-XXXX
  /^\(\d{3}\)\d{7}$/, // (XXX)XXXXXXX (parens, no other separators)

  // 11-digit formats (with country code 1)
  /^1\d{10}$/, // 1XXXXXXXXXX (no separators)
  /^1[-.\s]?\d{3}[-.\s]?\d{3}[-.\s]?\d{4}$/, // 1-XXX-XXX-XXXX (flexible separators)
  /^1[-.\s]?\(\d{3}\)\s?\d{3}[-.\s]?\d{4}$/, // 1(XXX)XXX-XXXX or 1 (XXX) XXX-XXXX
  /^1[-.\s]?\(\d{3}\)\d{7}$/, // 1(XXX)XXXXXXX or 1 (XXX)XXXXXXX

  // International formats (with +1)
  /^\+1[-.\s]?\d{3}[-.\s]?\d{3}[-.\s]?\d{4}$/, // +1-XXX-XXX-XXXX (flexible separators)
  /^\+1[-.\s]?\(\d{3}\)\s?\d{3}[-.\s]?\d{4}$/, // +1(XXX)XXX-XXXX or +1 (XXX) XXX-XXXX
  /^\+1[-.\s]?\(\d{3}\)\d{7}$/, // +1(XXX)XXXXXXX or +1 (XXX)XXXXXXX
];
